import React from 'react';
import './LandingPage.css';

export default function NotFound() {
  return (
    <div className="pageContainer">
      <div className="messageContainer">
        <h2 className="messageTitle">Não há nada para ver aqui!!</h2>
        <p className="messageText">Contacte o administrador</p>
      </div>
    </div>
  );
}
